import Component from "./_external/islands/Contents.vue";
import { mountIslandComponent } from "./_/_/vue";
const scheduled = new WeakSet();
export function mountIslands(root = document) {
	for (const element of root.querySelectorAll("[data-astral-component]")) {
		if (element.dataset.astralComponent !== "astral:islands/entry/WyJ2dWUiLCJpc2xhbmRzL0NvbnRlbnRzLnZ1ZSJd/astral-island-component-29cc87d89fa8bcc886d9a7c67d0480cb855fddb8007c7c4f6c510aba0e8b7db1.ts" || scheduled.has(element)) continue;
		const client = element.dataset.astralClient;
		if (client !== "load" && client !== "idle" && client !== "visible" && client !== "media") continue;
		scheduled.add(element);
		mountIslandComponent({
			id: element.id,
			component: Component,
			props: JSON.parse(element.dataset.astralProps ?? "{}"),
			client,
			media: element.dataset.astralMedia ?? null
		});
	}
}
mountIslands();
